<form-summary [data]="dataEpe" [report]="true"></form-summary>
<form-summary [data]="dataProject"></form-summary>